import { useCallback, useEffect, useState, createRef } from 'react'
import { useEffectOnce } from 'usehooks-ts'
import styled from 'styled-components'
import headerImage from './images/header.jpg'
import zhWappen from './images/zh-wappen-2.svg'
import headerImageWide from './images/header-wide.jpg'
import Authors from 'components/Authors'

const Header = ({
  tenant,
  colorMode,
  title,
  lead,
}: {
  tenant?: object
  colorMode?: string
  title: string
  lead: string
}) => {
  const [hasHeader, setHasHeader] = useState(false)
  const [isMobile, setIsMobile] = useState(false)
  const [isWide, setIsWide] = useState(false)

  const handleResize = (): void => {
    setIsMobile(window.innerWidth < 711)
    setIsWide(
      window.innerWidth >= 1360 || window.innerWidth > window.innerHeight
    )
  }

  useEffectOnce(() => {
    const headerElement = document.querySelector('[class*=FullHeader_root]')
    if (headerElement) {
      setHasHeader(true)
    }
    // set height when window is resized
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  })

  return (
    <HeaderWrapper>
      <TopWrapper>
        <div className='header-image'>
          <img src={isWide ? headerImageWide : headerImage} alt='header' />
        </div>
        <div className='title-wrapper'>
          <div className='titles'>
            <img
              src={zhWappen}
              alt={'Kantonswappen Zürich'}
              className='cantonFlag'
            ></img>
            <h1 dangerouslySetInnerHTML={{ __html: title }}></h1>
            <h2>{lead}</h2>
          </div>
        </div>
      </TopWrapper>

      <div className='authors'>
        <Authors
          authors={[
            { name: 'Larissa Rhyn', unityID: '19478725' },
            { name: 'Patrick Vögeli (Grafik)', unityID: '65386355' },
          ]}
          tenant={
            tenant
              ? tenant
              : {
                  key: 'tagesanzeiger',
                  name: 'Tages-Anzeiger',
                  domain: 'tagesanzeiger',
                  feedId: 2,
                  lang: 'de',
                }
          }
        />

        <div className='publication'>Publiziert am 30. September 2023</div>
      </div>
    </HeaderWrapper>
  )
}

const HeaderWrapper = styled.div`
  .publication {
    font-size: 1.2rem;
    color: var(--gray-3);
    margin-bottom: 60px;
    text-align: center;
    z-index: 10;
    position: relative;
  }
`

const TopWrapper = styled.div`
  background-color: transparent;
  overflow: hidden;
  position: relative;

  .header-image {
    background-color: #474b45;
    position: relative;
    width: 100%;
    height: 70vh;
    @media only screen and (max-width: 711px) {
      height: 75vh;
    }
    min-height: 450px;
    @media (orientation: landscape) {
      min-height: 600px;
    }
    object-fit: cover;
    img,
    div {
      width: 100%;
      height: 100%;
      position: absolute;
      object-fit: cover;
      overflow: visible;
      z-index: 1;
    }
  }

  .title-wrapper {
    z-index: 2;
    width: 668px;
    @media only screen and (max-width: 711px) {
      max-width: 80%;
    }
    position: absolute;
    top: 50%;
    left: 50%;
    @media only screen and (min-width: 0) {
      transform: translate(-50%, -100%);
    }
    @media only screen and (min-width: 768px) {
      transform: translate(-50%, -55%);
    }
    @media only screen and (min-width: 1200px) {
      transform: translate(-50%, -75%);
    }
    .titles {
      width: 100%;
      z-index: 99;
      top: 10vh;
      position: relative;
      @media only screen and (max-width: 711px) {
        top: 31vh;
      }
      @media (orientation: landscape) and (max-height: 1000px) {
        top: 18vh;
      }
      img {
        width: 80px;
        opacity: 0.95;
        margin-bottom: 1rem;
        display: flex;
        align-self: center;
        margin-left: auto;
        margin-right: auto;

        @media only screen and (min-width: 0) {
          width: 30px;
        }
        @media only screen and (min-width: 768px) {
          width: 50px;
        }
        @media only screen and (min-width: 1200px) {
          width: 60px;
        }
      }
      h1 {
        position: relative;
        margin: 0 auto;
        font-family: 'Suez One', serif;
        font-weight: 100;
        color: #fff;
        text-align: center;
        line-height: 0.6em;
        text-shadow: 1px 1px 15px #000, 1px 1px 15px #000;
        @media only screen and (min-width: 0px) {
          font-size: 3.5rem;
          line-height: 4rem;
          _color: red;
        }
        @media only screen and (min-width: 375px) {
          font-size: 4rem;
          line-height: 4.5rem;
          _color: red;
        }
        @media only screen and (min-width: 768px) {
          font-size: 7rem;
          line-height: 8rem;
          _color: yellow;
        }
        @media only screen and (min-width: 1200px) {
          font-size: 9rem;
          line-height: 10rem;
          _color: orange;
          text-shadow: 1px 1px 40px #000, 1px 1px 40px #000;
        }
        @media (orientation: landscape) and (max-height: 1000px) {
          _color: green;
          font-size: 7rem;
          line-height: 8rem;
        }
      }
      h2 {
        position: relative;
        left: -3.5%; // weird correction
        font-family: var(--font-sans-serif);
        color: #fff;
        padding: 1rem;
        font-weight: 300;
        font-size: 2.4rem;
        width: 100%;
        text-align: center;
        line-height: 1.3em;
        text-shadow: 1px 1px 8px #000, 1px 1px 8px #000;
        @media only screen and (max-width: 711px) {
          padding-top: 5vh;
          font-size: 2rem;
        }
      }
    }
  }
`

export default Header
